import { render, staticRenderFns } from "./layerDetail.vue?vue&type=template&id=1824f963&scoped=true"
import script from "./layerDetail.vue?vue&type=script&lang=js"
export * from "./layerDetail.vue?vue&type=script&lang=js"
import style0 from "./layerDetail.vue?vue&type=style&index=0&id=1824f963&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1824f963",
  null
  
)

export default component.exports